module.exports = __webpack_public_path__ + "img/21.c6b87f12.png";